// ----------------------------------------------------------------------------
// Snippet: Search
// ----------------------------------------------------------------------------
// Search bar, on header and on the Search Results template.
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_search-form.scss';

// Variables
var SEARCH_FORM = '.search-box';
var SEARCH_ICON = '.search-box__toggle';
var SEARCH_INPUT = '.search__input';
var SEARCH_CLOSE = '.search__close';
var PREDICTIVE_SEARCH = '#predictive-search';
var FORM_LABEL = '.form__label';
var SEARCH_OVERLAY = '#search-overlay';

// Functions
function openSearchForm(searchForm) {
  if (searchForm != null) {
    searchForm.classList.add('is-active');
    var searchOverlay = document.querySelector(SEARCH_OVERLAY);
    var searchInput = searchForm.querySelector(SEARCH_INPUT);
    if (searchInput != null) {
      searchInput.focus();
    }
    var currentScrollX = window.scrollX;
    var currentScrollY = window.scrollY;
    window.scrollTo(currentScrollX, currentScrollY);
    searchOverlay.style.display = 'block';
  }
}
function closeSearchForm(searchForm) {
  if (searchForm != null) {
    searchForm.classList.remove('is-active');
    var predictiveSearch = searchForm.querySelector(PREDICTIVE_SEARCH);
    var searchInput = searchForm.querySelector(SEARCH_INPUT);
    var searchOverlay = document.querySelector(SEARCH_OVERLAY);
    if (predictiveSearch != null) {
      predictiveSearch.style.display = 'none';
    }
    if (searchInput != null) {
      searchInput.value = '';
    }
    searchOverlay.style.display = 'none';
  }
}

// If you click anywhere outside of the search, close it
document.body.addEventListener('click', function (event) {
  if (event.target.closest(SEARCH_FORM) == null && document.querySelector(SEARCH_FORM) != null) {
    var searchForms = document.querySelectorAll(SEARCH_FORM);
    searchForms.forEach(searchForm => {
      closeSearchForm(searchForm);
    });
  }
});
document.addEventListener('DOMContentLoaded', function () {
  // When you click the close button, remove open class and clean input
  var searchCloseIcons = document.querySelectorAll(SEARCH_CLOSE);
  searchCloseIcons.forEach(searchClose => {
    searchClose.addEventListener('click', function (event) {
      var searchForm = event.target.closest(SEARCH_FORM);
      closeSearchForm(searchForm);
    });
  });

  // When you click the search icon, toggle the open state
  var searchIcons = document.querySelectorAll(SEARCH_ICON);
  searchIcons.forEach(searchIcon => {
    searchIcon.addEventListener('click', function (event) {
      event.preventDefault();
      var searchForm = event.target.closest(SEARCH_FORM);
      searchForm.classList.contains('is-active') ? closeSearchForm(searchForm) : openSearchForm(searchForm);
    });
  });

  // When the search input is in focus state and you click Escape, close the searchbox
  var searchInputs = document.querySelectorAll(SEARCH_INPUT);
  searchInputs.forEach(searchInput => {
    searchInput.addEventListener('keyup', function (e) {
      if (e.key == 'Escape') {
        var searchForm = e.target.closest(SEARCH_FORM);
        closeSearchForm(searchForm);
      }
    });
  });

  // Allows label on mobile to also target the search
  var searchForms = document.querySelectorAll(SEARCH_FORM);
  searchForms.forEach(searchForm => {
    var formLabel = searchForm.querySelector(FORM_LABEL);
    formLabel.addEventListener('click', function (event) {
      var searchForm = event.target.closest(SEARCH_FORM);
      searchForm.classList.contains('is-active') ? closeSearchForm(searchForm) : openSearchForm(searchForm);
    });
  });
});